export enum ApplyFileStatusType {
    NotApplicable = -1,
    No = 0,
    Pending = 1,
    Approved = 2,
    Rejected = 3,
}
